import { Field, Formik, FormikHelpers } from "formik";
import { Col, Row } from "react-grid-system";
import { StyledField } from "../../styles/StyledField";
import * as Yup from "yup";
import { postChangeUserPassword } from "../../api/user/profile";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { Button } from "../Button";
import { ReactNode, useState } from "react";
import { toast } from "react-toastify";
import { SError, SForm, SFormFooter } from "../../styles/ChangePassword";
import SaveIcon from "../../assets/img/icons/save.svg";

export type BEErrorType = {
	path: string;
	message: string;
};

type ChangePasswordType = {
	oldPassword: string;
	newPassword: string;
	retypedNewPassword: string;
};

const ChangePasswordSchema = Yup.object({
	oldPassword: Yup.string().required("Required"),
	newPassword: Yup.string().required("Required"),
	retypedNewPassword: Yup.string().oneOf([Yup.ref("newPassword"), null], "Passwords must match"),
});

export const ChangePassword = () => {
	const { axiosPrivate } = useAxiosPrivate();

	const [beValidationErrors, setBeValidationErrors] = useState<ReactNode | ReactNode[]>([]);

	const initialValues: ChangePasswordType = {
		oldPassword: "",
		newPassword: "",
		retypedNewPassword: "",
	};
	const handleSubmit = async (values: ChangePasswordType, formikHelpers: FormikHelpers<ChangePasswordType>) => {
		const { oldPassword, newPassword } = values;
		setBeValidationErrors([]);
		const res = await postChangeUserPassword(axiosPrivate, { oldPassword, newPassword });
		if (res.data.status === false) {
			setBeValidationErrors(<SError>{res.data.message}</SError>);
			toast.error("Could not change password. Please try again.");
			return true;
		}
		if (res?.data?.code === 400) {
			toast.error("Could not change password. Please try again.");
			if (res.data.fieldErrors) {
				const k = res.data.fieldErrors?.map((error: BEErrorType, i: number) => <SError key={i}>{error.message}</SError>);
				setBeValidationErrors(k);
			}
		}
		if (res.status === 200) {
			formikHelpers.resetForm();
		}
		return true;
	};
	return (
		<>
			<Row>
				<Col>
					<h3>Change password</h3>
				</Col>
			</Row>
			<Row>
				<Col md={4}>
					<Formik initialValues={initialValues} onSubmit={handleSubmit} validationSchema={ChangePasswordSchema}>
						{({ errors, touched, isValid, isSubmitting }) => {
							return (
								<SForm>
									<StyledField style={{ marginTop: "1rem" }}>
										<label>Current password</label>
										<Field name="oldPassword" type="password"></Field>
										{errors.oldPassword && touched.oldPassword ? <span>{errors.oldPassword}</span> : null}
									</StyledField>
									<StyledField>
										<label>New password</label>
										<Field name="newPassword" type="password"></Field>
										{errors.newPassword && touched.newPassword ? <span>{errors.newPassword}</span> : null}
									</StyledField>
									<StyledField>
										<label>Confirm new password</label>
										<Field name="retypedNewPassword" type="password"></Field>
										{errors.retypedNewPassword && touched.retypedNewPassword ? <span>{errors.retypedNewPassword}</span> : null}
									</StyledField>
									{beValidationErrors}
									<SFormFooter>
										<Button type="reset" onClick={() => setBeValidationErrors([])}>
											Cancel
										</Button>
										<Button type="submit" icon={SaveIcon} disabled={!isValid || isSubmitting}>
											Save changes
										</Button>
									</SFormFooter>
								</SForm>
							);
						}}
					</Formik>
				</Col>
			</Row>
		</>
	);
};
